"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scorecardHandler = exports.SCORECARD_MOSTLY_NOT_SURE_THRESHOLD = exports.SCORECARD_NOTE_MAX_LENGTH = exports.SCORECARD_ID_MAX = exports.SCORECARD_ID_MIN = exports.SCORECARD_MOSTLY_NOT_SURE_CAVEAT = exports.SCORECARD_COPY_VERSION = void 0;
exports.pointsForAnswer = pointsForAnswer;
exports.bandForScore = bandForScore;
exports.countNotSure = countNotSure;
exports.scorecardMostlyNotSureCaveat = scorecardMostlyNotSureCaveat;
exports.displayTitleForCriterion = displayTitleForCriterion;
exports.validateScorecardInput = validateScorecardInput;
exports.buildThingsToCheck = buildThingsToCheck;
exports.thingTitlesFor = thingTitlesFor;
exports.questionsForWhatsApp = questionsForWhatsApp;
exports.buildWhatsAppMessage = buildWhatsAppMessage;
exports.rankScorecardIds = rankScorecardIds;
exports.biggestDifferenceAcross = biggestDifferenceAcross;
const enums_js_1 = require("./enums.js");
const scorecard_copy_js_1 = require("./scorecard-copy.js");
const tools_js_1 = require("./tools.js");
var scorecard_copy_js_2 = require("./scorecard-copy.js");
Object.defineProperty(exports, "SCORECARD_COPY_VERSION", { enumerable: true, get: function () { return scorecard_copy_js_2.SCORECARD_COPY_VERSION; } });
Object.defineProperty(exports, "SCORECARD_MOSTLY_NOT_SURE_CAVEAT", { enumerable: true, get: function () { return scorecard_copy_js_2.SCORECARD_MOSTLY_NOT_SURE_CAVEAT; } });
exports.SCORECARD_ID_MIN = 1;
exports.SCORECARD_ID_MAX = 3;
exports.SCORECARD_NOTE_MAX_LENGTH = 280;
exports.SCORECARD_MOSTLY_NOT_SURE_THRESHOLD = 6;
const ESCROW_TITLE = "Escrow Payment";
const DEFAULT_SIGNER = "[first name]";
const ANSWER_SET = new Set(enums_js_1.SCORECARD_ANSWERS);
function isRecord(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
function error(field, code) {
    return { field, code };
}
function pointsForAnswer(maxPoints, answer) {
    if (answer === "yes") {
        return maxPoints;
    }
    if (answer === "partially") {
        return maxPoints / 2;
    }
    return 0;
}
function bandForScore(score) {
    if (score >= 80) {
        return "strong_confidence";
    }
    if (score >= 65) {
        return "investigate_further";
    }
    return "slow_down";
}
function countNotSure(answers) {
    return answers.filter((answer) => answer === "not_sure").length;
}
/** Caveat when ≥6 answers are Not sure yet; otherwise undefined. */
function scorecardMostlyNotSureCaveat(answers) {
    if (countNotSure(answers) >= exports.SCORECARD_MOSTLY_NOT_SURE_THRESHOLD) {
        return scorecard_copy_js_1.SCORECARD_MOSTLY_NOT_SURE_CAVEAT;
    }
    return undefined;
}
function displayTitleForCriterion(criterion) {
    if (criterion === ESCROW_TITLE) {
        return scorecard_copy_js_1.SCORECARD_ESCROW_DISPLAY_TITLE;
    }
    return criterion;
}
function parseAnswers(raw, idIndex) {
    if (!Array.isArray(raw)) {
        return { ok: false, errors: [error(`ids[${idIndex}].answers`, "required")] };
    }
    if (raw.length !== tools_js_1.SCORECARD_CRITERIA.length) {
        return { ok: false, errors: [error(`ids[${idIndex}].answers`, "answer_count")] };
    }
    const answers = [];
    const errors = [];
    for (let i = 0; i < raw.length; i++) {
        const answer = raw[i];
        if (typeof answer !== "string" || !ANSWER_SET.has(answer)) {
            errors.push(error(`ids[${idIndex}].answers[${i}]`, "invalid_answer"));
        }
        else {
            answers.push(answer);
        }
    }
    if (errors.length > 0) {
        return { ok: false, errors };
    }
    return { ok: true, value: answers };
}
function parseNotes(raw, idIndex) {
    if (raw === undefined) {
        return { ok: true, value: undefined };
    }
    if (!Array.isArray(raw)) {
        return { ok: false, errors: [error(`ids[${idIndex}].notes`, "invalid_notes")] };
    }
    if (raw.length > tools_js_1.SCORECARD_CRITERIA.length) {
        return { ok: false, errors: [error(`ids[${idIndex}].notes`, "notes_length")] };
    }
    const notes = [];
    const errors = [];
    for (let i = 0; i < raw.length; i++) {
        const note = raw[i];
        if (note === null || note === undefined) {
            notes.push(null);
            continue;
        }
        if (typeof note !== "string") {
            errors.push(error(`ids[${idIndex}].notes[${i}]`, "invalid_note"));
            continue;
        }
        if (note.length > exports.SCORECARD_NOTE_MAX_LENGTH) {
            errors.push(error(`ids[${idIndex}].notes[${i}]`, "note_too_long"));
            continue;
        }
        notes.push(note);
    }
    if (errors.length > 0) {
        return { ok: false, errors };
    }
    return { ok: true, value: notes };
}
function parseId(raw, index) {
    if (!isRecord(raw)) {
        return { ok: false, errors: [error(`ids[${index}]`, "invalid_id")] };
    }
    const name = typeof raw.name === "string" ? raw.name.trim() : "";
    if (!name) {
        return { ok: false, errors: [error(`ids[${index}].name`, "required")] };
    }
    const answersResult = parseAnswers(raw.answers, index);
    if (answersResult.ok === false) {
        return answersResult;
    }
    const notesResult = parseNotes(raw.notes, index);
    if (notesResult.ok === false) {
        return notesResult;
    }
    return {
        ok: true,
        value: {
            name,
            answers: answersResult.value,
            ...(notesResult.value !== undefined ? { notes: notesResult.value } : {}),
        },
    };
}
function validateScorecardInput(input) {
    if (!isRecord(input)) {
        return { ok: false, errors: [error("input", "invalid")] };
    }
    if (!Array.isArray(input.ids)) {
        return { ok: false, errors: [error("ids", "required")] };
    }
    if (input.ids.length < exports.SCORECARD_ID_MIN || input.ids.length > exports.SCORECARD_ID_MAX) {
        return { ok: false, errors: [error("ids", "id_count")] };
    }
    const errors = [];
    const ids = [];
    const seenNames = new Set();
    for (let i = 0; i < input.ids.length; i++) {
        const parsed = parseId(input.ids[i], i);
        if (parsed.ok === false) {
            errors.push(...parsed.errors);
            continue;
        }
        const key = parsed.value.name.toLowerCase();
        if (seenNames.has(key)) {
            errors.push(error(`ids[${i}].name`, "duplicate_name"));
        }
        else {
            seenNames.add(key);
            ids.push(parsed.value);
        }
    }
    let signerFirstName;
    if (input.signerFirstName !== undefined) {
        if (typeof input.signerFirstName !== "string" || !input.signerFirstName.trim()) {
            errors.push(error("signerFirstName", "invalid_signer_first_name"));
        }
        else {
            signerFirstName = input.signerFirstName.trim();
        }
    }
    if (errors.length > 0) {
        return { ok: false, errors };
    }
    return {
        ok: true,
        value: {
            ids,
            ...(signerFirstName !== undefined ? { signerFirstName } : {}),
        },
    };
}
function buildCriteria(id) {
    return tools_js_1.SCORECARD_CRITERIA.map((criterion, index) => {
        const answer = id.answers[index];
        const note = id.notes?.[index];
        return {
            criterion: criterion.title,
            answer,
            points: pointsForAnswer(criterion.maxPoints, answer),
            ...(note != null && note !== "" ? { note } : {}),
        };
    });
}
function buildEscrowThing(idName, answer) {
    const copy = scorecard_copy_js_1.SCORECARD_ESCROW_COPY[answer];
    return {
        criterion: ESCROW_TITLE,
        answer,
        title: scorecard_copy_js_1.SCORECARD_ESCROW_DISPLAY_TITLE,
        recommendation: (0, scorecard_copy_js_1.fillIdPlaceholder)(copy.recommendation, idName),
        question: (0, scorecard_copy_js_1.fillIdPlaceholder)(copy.question, idName),
    };
}
function buildNonEscrowThing(criterion, answer) {
    const copy = scorecard_copy_js_1.SCORECARD_THING_COPY[criterion];
    return {
        criterion,
        answer,
        recommendation: copy.recommendation,
        question: copy.question,
    };
}
function escrowAnswerFor(id) {
    const index = tools_js_1.SCORECARD_CRITERIA.findIndex((criterion) => criterion.title === ESCROW_TITLE);
    return id.answers[index] ?? "yes";
}
/**
 * Things to check = non-Yes answers only (TRD S-04 `things_to_check_count`).
 * Escrow / How You'll Pay is appended only when it is also non-Yes (always last).
 * When escrow is Yes, UI/PDF still render the How You'll Pay section from `escrowAnswer`
 * — it is not counted here. All-Yes is the exception: two last steps, including How You'll Pay.
 */
function buildThingsToCheck(id) {
    const allYes = id.answers.every((answer) => answer === "yes");
    if (allYes) {
        return [
            {
                criterion: "Commitment Confidence",
                answer: "yes",
                title: scorecard_copy_js_1.SCORECARD_ALL_YES_WRITING_TITLE,
                recommendation: scorecard_copy_js_1.SCORECARD_ALL_YES_WRITING_COPY.recommendation,
                question: scorecard_copy_js_1.SCORECARD_ALL_YES_WRITING_COPY.question,
            },
            buildEscrowThing(id.name, "yes"),
        ];
    }
    const nonEscrowGaps = [];
    let escrowAnswer = "yes";
    for (let i = 0; i < tools_js_1.SCORECARD_CRITERIA.length; i++) {
        const criterion = tools_js_1.SCORECARD_CRITERIA[i];
        const answer = id.answers[i];
        if (criterion.title === ESCROW_TITLE) {
            escrowAnswer = answer;
            continue;
        }
        if (answer !== "yes") {
            nonEscrowGaps.push({
                title: criterion.title,
                maxPoints: criterion.maxPoints,
                answer,
            });
        }
    }
    nonEscrowGaps.sort((a, b) => b.maxPoints - a.maxPoints || a.title.localeCompare(b.title));
    const things = nonEscrowGaps.map((gap) => buildNonEscrowThing(gap.title, gap.answer));
    if (escrowAnswer !== "yes") {
        things.push(buildEscrowThing(id.name, escrowAnswer));
    }
    return things;
}
function thingTitlesFor(things) {
    return things.map((thing) => thing.title ?? thing.criterion);
}
/**
 * WhatsApp questions follow the report list. When escrow is Yes it is not in
 * `thingsToCheck` (S-04 count), but the How You'll Pay Yes question is still
 * appended last so the message matches the report section.
 */
function questionsForWhatsApp(id, thingsToCheck) {
    const hasEscrowInList = thingsToCheck.some((thing) => thing.criterion === ESCROW_TITLE);
    if (escrowAnswerFor(id) === "yes" && !hasEscrowInList) {
        return [...thingsToCheck, buildEscrowThing(id.name, "yes")];
    }
    return [...thingsToCheck];
}
function buildWhatsAppMessage(idName, things, signerFirstName = DEFAULT_SIGNER) {
    const questions = things.map((thing, index) => `${index + 1}. ${thing.question}`).join("\n\n");
    return `Hi ${idName}, thanks for meeting me. Before we go further, I have a few questions:\n\n${questions}\n\nThanks! ${signerFirstName}`;
}
function scoreId(id, signerFirstName) {
    const criteria = buildCriteria(id);
    const score = criteria.reduce((sum, row) => sum + row.points, 0);
    const thingsToCheck = buildThingsToCheck(id);
    return {
        name: id.name,
        score,
        band: bandForScore(score),
        criteria,
        thingsToCheck,
        whatsAppMessage: buildWhatsAppMessage(id.name, questionsForWhatsApp(id, thingsToCheck), signerFirstName),
    };
}
/**
 * Rank IDs by score desc. Ties share the competition rank and prefer fewer
 * things to check, then original input order.
 */
function rankScorecardIds(scored) {
    const ordered = [...scored].sort((a, b) => {
        if (b.score !== a.score) {
            return b.score - a.score;
        }
        if (a.thingsToCheckCount !== b.thingsToCheckCount) {
            return a.thingsToCheckCount - b.thingsToCheckCount;
        }
        return a.inputIndex - b.inputIndex;
    });
    const ranks = [];
    let i = 0;
    while (i < ordered.length) {
        let j = i + 1;
        while (j < ordered.length && ordered[j].score === ordered[i].score) {
            j++;
        }
        const tied = j - i > 1;
        const rank = i + 1;
        for (let k = i; k < j; k++) {
            ranks.push({ name: ordered[k].name, rank, tied });
        }
        i = j;
    }
    return ranks;
}
/** Criterion title with the largest absolute point delta across IDs. */
function biggestDifferenceAcross(ids) {
    if (ids.length < 2) {
        return undefined;
    }
    let bestTitle;
    let bestDelta = -1;
    for (let c = 0; c < tools_js_1.SCORECARD_CRITERIA.length; c++) {
        const points = ids.map((id) => id.criteria[c]?.points ?? 0);
        const delta = Math.max(...points) - Math.min(...points);
        if (delta > bestDelta) {
            bestDelta = delta;
            bestTitle = tools_js_1.SCORECARD_CRITERIA[c].title;
        }
    }
    return bestDelta > 0 ? bestTitle : undefined;
}
function analyse(input) {
    const signer = input.signerFirstName?.trim() || DEFAULT_SIGNER;
    const ids = input.ids.map((id) => scoreId(id, signer));
    const ranking = rankScorecardIds(ids.map((id, inputIndex) => ({
        name: id.name,
        score: id.score,
        thingsToCheckCount: id.thingsToCheck.length,
        inputIndex,
    })));
    const orderByName = new Map(ranking.map((row, index) => [row.name, index]));
    const orderedForPreview = [...ids].sort((a, b) => (orderByName.get(a.name) ?? 0) - (orderByName.get(b.name) ?? 0));
    return { ids: orderedForPreview, ranking, orderedForPreview };
}
function previewFrom(input) {
    const { ids, ranking, orderedForPreview } = analyse(input);
    const primary = orderedForPreview[0];
    const primaryInput = input.ids.find((id) => id.name === primary.name) ?? input.ids[0];
    const titles = thingTitlesFor(primary.thingsToCheck);
    const preview = {
        toolKey: "id_scorecard",
        ids: ids.map((id) => ({
            name: id.name,
            score: id.score,
            band: id.band,
        })),
        thingsToCheckCount: primary.thingsToCheck.length,
        thingTitles: titles.slice(0, 2),
        notSureCount: countNotSure(primaryInput.answers),
        escrowAnswer: primaryInput.answers[tools_js_1.SCORECARD_CRITERIA.findIndex((c) => c.title === ESCROW_TITLE)],
    };
    if (ids.length >= 2) {
        preview.ranking = ranking;
        const diff = biggestDifferenceAcross(ids);
        if (diff !== undefined) {
            preview.biggestDifference = diff;
        }
    }
    return preview;
}
function summariseScorecard(result) {
    const top = result.ids[0];
    const label = top ? scorecard_copy_js_1.SCORECARD_BAND_LABELS[top.band] : "";
    const headline = result.ids.length === 1 && top
        ? `${top.name}: ${formatScore(top.score)}/100, ${label}`
        : result.ids.map((id) => `${id.name} ${formatScore(id.score)}`).join(" · ");
    const caveats = result.ids
        .map((id) => {
        const answers = id.criteria.map((row) => row.answer);
        const caveat = scorecardMostlyNotSureCaveat(answers);
        return caveat ? `${id.name}: ${caveat}` : undefined;
    })
        .filter((line) => line !== undefined);
    const summaryParts = result.ids.map((id) => `${id.name} ${formatScore(id.score)}/100 ${scorecard_copy_js_1.SCORECARD_BAND_LABELS[id.band]} (${id.thingsToCheck.length} to check)`);
    return {
        headline,
        summaryText: [...summaryParts, ...caveats].join(". "),
        toolDataText: [
            `copy_version=${scorecard_copy_js_1.SCORECARD_COPY_VERSION}`,
            `ids=${result.ids.map((id) => `${id.name}:${formatScore(id.score)}:${id.band}`).join("|")}`,
            `things=${result.ids.map((id) => id.thingsToCheck.length).join("|")}`,
            caveats.length > 0 ? "mostlyNotSure=true" : "mostlyNotSure=false",
        ].join("; "),
    };
}
function formatScore(score) {
    return Number.isInteger(score) ? String(score) : score.toFixed(1);
}
exports.scorecardHandler = {
    validate: validateScorecardInput,
    preview(input) {
        return previewFrom(input);
    },
    run(input) {
        const { ids, ranking } = analyse(input);
        const result = {
            toolKey: "id_scorecard",
            ids,
        };
        if (ids.length >= 2) {
            result.ranking = ranking;
        }
        return result;
    },
    summarise: summariseScorecard,
};
